import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getDairyFeedInformation } from "services";

import { GET_DAIRY_FEED_INFORMATION } from "consts";

export const useGetFootprintingDairyFeedInformationByPrimaryDataId = (FeedInformationId: string) => {
  const queryClient = useQueryClient();
  return useQuery(
    {
      queryKey: [GET_DAIRY_FEED_INFORMATION, FeedInformationId],
      queryFn: () => getDairyFeedInformation(FeedInformationId),
      enabled: !!FeedInformationId,
      gcTime: 60000,
    },
    queryClient
  );
};
